module.exports = angular.module('saphene', [ 'AxelSoft', 'ngDialog', 'ngAnimate' ])
  .run([ '$templateCache', function($templateCache) {
    $templateCache.put('templates/popup-contact.jade', require('./templates/popup-contact.jade')());
  }])
  .controller('AppController', require('./app.controller.js'))
  .controller('FormContactController', require('./formContact.controller.js'))
;


//////////////////
// WEBPACK FOOTER
// ./assets/app/app.js
// module id = 0
// module chunks = 0